export default "__VITE_ASSET__BjF2RSqI__"